import { ReactNode, useRef } from "react";

type TooltipProps = {
    children: ReactNode;
    tooltip?: string;
};

export const Tooltip: React.FC<TooltipProps> = ({ children, tooltip }) => {
    const tooltipRef = useRef<HTMLSpanElement>(null);
    const container = useRef<HTMLDivElement>(null);

    return (
        <div
            ref={container}
            className="group relative inline-block"
            onMouseEnter={({ clientX }) => {
                if (!tooltipRef.current || !container.current) return;
                const { left } = container.current.getBoundingClientRect();

                tooltipRef.current.style.left = clientX - left + "px";
            }}
        >
            {children}
            {tooltip ? (
                <span
                    className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition bg-button text-white p-1 rounded absolute top-full mt-2 whitespace-nowrap text-sm"
                    ref={tooltipRef}
                >
                    {tooltip}
                </span>
            ) : null}
        </div>
    );
};
